import React, {useEffect, useState} from "react";
import {homeHippodrome, homeHippodromeSubject} from "../../store/misc.store";
import {useForceUpdate} from "../../services/misc.functions";
import {HippodromeWidget} from "../../shared/hippodrome/hippodrome";


export function NotRunningHorses() {
    const [horses, setHorses] = useState<any>([]);
    const forceUpdate = useForceUpdate();

    useEffect(() => {
        let homeHippodromeSubject_subscription = homeHippodromeSubject.subscribe((res: any) => {
            forceUpdate();
            getNotRunningHorses();
        })
        return () => {
            homeHippodromeSubject_subscription.unsubscribe();
        }
    }, []);

    useEffect(() => {
        getNotRunningHorses();
    }, []);

    const getNotRunningHorses = () => {
        var notRunningHorses = [];
        if (homeHippodrome.runs) {
            for (const run of homeHippodrome.runs) {
                for (const horse of run.horses) {
                    if (!horse.run_status) {
                        horse.run_no = run.no;
                        notRunningHorses.push(horse);
                    }
                }
            }
        }


        setHorses(notRunningHorses);
    }
    return <>
        <div className="page-title-wrapper ">
            <HippodromeWidget/>
        </div>
        <div className={"container"}>
            {horses.length > 0 &&
                <table className={"table w-100 widget-table not-running-horse-table"}>
                    <thead>
                    <tr>
                        <th>Koşu</th>
                        <th>No.</th>
                        <th>Atın İsmi</th>

                    </tr>
                    </thead>
                    <tbody>
                    {horses?.map((horse: any, runsIndex: number) => {
                        return (<React.Fragment key={`notRuningHorse-i-${runsIndex}`}>
                            <tr>
                                <td className="d-flex justify-content-center align-items-center align-content-center">{horse.run_no}</td>
                                <td className="d-flex justify-content-center align-items-center align-content-center">{horse.no}</td>
                                <td>{horse.name}</td>
                            </tr>
                        </React.Fragment>)
                    })}
                    </tbody>
                </table>}

            {
                horses.length === 0 &&
                <div className={"d-flex flex-column justify-content-center align-content-center align-items-center"}
                     style={{minHeight: '380px'}}>

                    <p className={"text-green text-xsmall text-bold text-center"}>Şuan koşmayan at bulunmuyor!</p>
                </div>
            }
        </div>
    </>
}
